// extracted by css-extract-rspack-plugin
export default {"wrapper":"PaymentConfirm-module__wrapper","pendingBanner":"PaymentConfirm-module__pendingBanner"};